import React, {useState, useEffect} from 'react'
import { Form, Tabs, Steps } from 'antd'
import styled from '@emotion/styled'
import { StyledAlert } from 'components'
import {
	StyledPreLoginAlert,
	TrialButton, 
	StyledButtonContainer
} from 'views/PreLogin/styled'
import useAxios from 'axios-hooks'
import DetailsStep from './Steps/Details'
import UrlStep from './Steps/WebsiteUrl'
import ScanResult from './Steps/ScanResult'
import {stepsDetails} from './Steps/data';
import {StepForwardOutlined} from '@ant-design/icons';

const {Step} = Steps;
const { TabPane } = Tabs

export const StyledSteps = styled(Steps)`
	padding-top: 20px;	
	margin-bottom: 30px;
	.ant-steps-item-title{
		font-weight: 300;
		font-size: 10px;
		line-height: 0;
	}
`

export const StyledContainer = styled.div`
	margin: 20px;
`

export const StyledTabs = styled(Tabs)`
	.ant-tabs-bar.ant-tabs-top-bar{
		display: none;
	}
`
  
function CreateAccountFrame({ form }) {
	const [step, setStep] = useState(stepsDetails[0].name);
	const [errorMessage, setErrorMessage] = useState(null);
	const [token, setToken] = useState(null);
	const [scanDetails, setScanDetails] = useState(null);

	useEffect(() => {
		document.body.style.background = "white";
	}, [])

	return (
		<div>
			{<StyledSteps labelPlacement="vertical" current={stepsDetails.findIndex((s) => s.name == step)} percent={60}>
				<Step title={stepsDetails[0].title} />
				<Step title={stepsDetails[1].title} />
				<Step title={stepsDetails[2].title} />
			</StyledSteps>}
			<StyledContainer>
				<Form layout="vertical">
					{errorMessage && (
						<StyledPreLoginAlert>
							<StyledAlert showIcon type="error" message="Error" description={errorMessage} />
						</StyledPreLoginAlert>
					)}
					<StyledTabs defaultActiveKey={stepsDetails[0].name} activeKey={step}>
						<TabPane tab={null} key={stepsDetails[0].name}>
							<DetailsStep setErrorMessage={setErrorMessage} setStep={setStep} form={form} />
						</TabPane>
						<TabPane tab={null} key={stepsDetails[1].name}>
							<UrlStep setScanDetails={setScanDetails} setToken={setToken} setErrorMessage={setErrorMessage} setStep={setStep} form={form} />
						</TabPane>
						<TabPane tab={null} key={stepsDetails[2].name}>
							<ScanResult scanDetails={scanDetails} token={token} setErrorMessage={setErrorMessage} form={form} />
						</TabPane>
					</StyledTabs>		
				</Form>
			</StyledContainer>
		</div>
	)
}

export default Form.create({})(CreateAccountFrame);
